import { createSlice, current } from '@reduxjs/toolkit';
import _ from "lodash";

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    Current: undefined,
    Navigations: [],
    History: []
  },
  reducers: {
    setNavigations: (state, action) =>
    {
      state.Navigations = action.payload;

    },
    setCurrentNavigation: (state, action) => {
      

      let selectedNavigation = current(state).Navigations.find(n => n.code == action.payload);

      const params = new URLSearchParams(window.location.search);
      const paramsObject = Object.fromEntries(params.entries());

      const queryString = Object.keys(paramsObject).length !== 0
        ? `?${new URLSearchParams(paramsObject).toString()}`
        : '';


      selectedNavigation = {
            ...selectedNavigation,
        urlParams: paramsObject,
        urlParamsText: queryString
      };

      if (selectedNavigation)
      {

        let toUpdateHistory = _.cloneDeep(current(state).History);

        let indexToRemove = toUpdateHistory.findIndex(h => h._id == selectedNavigation._id);

        if (indexToRemove > -1)
        {
          toUpdateHistory.splice(indexToRemove, 1);
        }

        toUpdateHistory = [
          ...toUpdateHistory,
          selectedNavigation
        ];

        state.History = toUpdateHistory;

      }

      //Set Current navigation
      state.Current = {
        ...selectedNavigation,
        urlParams: paramsObject,
        urlParamsText: queryString
      };



    },
    removeFromHistory: (state, action) => {

      state.History = current(state).History.filter(h => h._id != action.payload._id);

    }
  }
});

export const { setNavigations, setCurrentNavigation, removeFromHistory } = navigationSlice.actions;

export const getNavigations = state => state.navigation.Navigations;

export const getCurrentNavigation = state => state.navigation.Current;

export const getNavigationAvailable = state => {

  if (!state.navigation.Current) return [];



  return state.navigation.Navigations.filter(m => ((state.navigation.Current.isParent && m.parentId == state.navigation.Current._id) || (!state.navigation.Current.isParent && m.parentId == state.navigation.Current.parentId)));

};

export const getPreviousNavigation = state => {


  let lastIndex = state.navigation.History.findLastIndex(h => h._id != state.navigation.Current._id);

  if (lastIndex > -1) return state.navigation.History[lastIndex];


  lastIndex = state.navigation.History.findIndex(h => h._id == state.navigation.Current.parentId);


  if (lastIndex > -1) return state.navigation.History[lastIndex];


  return state.navigation.Navigations.find(h => h.code == "Home");


};

export const getHistory = (state) => state.navigation.History;


export default navigationSlice.reducer;
